import React, {Component} from 'react';
import {browserHistory, Link, hashHistory} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {loginUser, fetchUser, loginWithProvider} from '../../actions/firebase_actions';
import {updateModal} from '../../actions/modal';
import {clearDraw} from '../../actions/ts_overlay_actions';
import {updateCanvas} from '../../actions/ts_canvas_actions';
import {getUserData} from '../../actions/ts_userData_actions';
import ResetPassword from '../reset_password/';
import Menu from '../menu/';
import Playbook from '../playbook/';
import Login_Register from '../login_register/';
import {TS_EMAIL_VERIFY,TS_PASS_VERIFY} from '../../actions/types';

class UserLogin extends Component {

  constructor(props) {
    super(props);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.formReset = this.formReset.bind(this);
    this.resetPassword = this.resetPassword.bind(this);
    this.state = {
      message: '',
       width: window.innerWidth,
    };
  }

componentWillMount() {
  window.addEventListener('resize', this.handleWindowSizeChange);
}

// make sure to remove the listener
// when the component is not mounted anymore
componentWillUnmount() {
  window.removeEventListener('resize', this.handleWindowSizeChange);
}

handleWindowSizeChange = () => {
  this.setState({ width: window.innerWidth });
};

  hideModal() {
    this.setState({show: false});
  }

  resetPassword(){
    this.props.updateModal(true,<ResetPassword/>);
  }

  onFormSubmit(event) {
    event.preventDefault();
    var {overlay,currentUser} = this.props;
    const email = this.refs.email.value;
    const password = this.refs.password.value;
    this.props.loginUser({email, password}).then((data) => {
      if (data.payload.errorCode) {
        this.setState({message: data.payload.errorMessage});
      } else {
        if (!data.payload.emailVerified)
        {
            this.setState({message: "You must verify your email before logging in."});
        }
        else {
          localStorage.removeItem(TS_EMAIL_VERIFY);
          localStorage.removeItem(TS_PASS_VERIFY);
          this.props.getUserData(data.payload.uid);
          hashHistory.replace('/home');
          this.props.clearDraw(overlay.color,overlay.color1,overlay.color2);
          this.props.updateCanvas(null,null,[]);
          this.props.updateModal(true,<Playbook/>);
        }


        //browserHistory.push('/home');
      }
    });
  }

  formReset() {
    event.preventDefault();
    localStorage.removeItem(TS_EMAIL_VERIFY);
    localStorage.removeItem(TS_PASS_VERIFY);
      this.props.updateModal(false,null);

  }

  handleEnter(event) {
  if (event.keyCode === 13) {
    const form = event.target.form;
    const index = Array.prototype.indexOf.call(form, event.target);
    form.elements[index + 1].focus();
    form.elements[index].blur();
    event.preventDefault();
  }
}

handleFocusOut(event) {
    const form = event.target.form;
    const index = Array.prototype.indexOf.call(form, event.target);
    form.elements[index].blur();
    event.preventDefault();
}


  render() {

var emailVerify;
var passVerify;
var buttonClear;
var session_email_verify = window.localStorage.getItem(TS_EMAIL_VERIFY);
var session_pass_verify = window.localStorage.getItem(TS_PASS_VERIFY);
if(session_email_verify && session_pass_verify)
{
emailVerify = session_email_verify;
passVerify = session_pass_verify;
buttonClear = <span>&nbsp;&nbsp;&nbsp;<button type="reset" onClick={this.formReset} className="buttonStyle">Clear</button></span>;
}
//If the email hasn't been verified, do not auto login.
//if (!currentUser.emailVerified)return;


    return (
      <div>
        <form id="frmLogin" role="form" onSubmit={this.onFormSubmit}>
          {/*  <span className="headerText">Login</span> */}
          <p className="errorText">
            {this.state.message}
          </p>
          <div className="form-group">
            <label className="titleText" htmlFor="txtEmail">Email Address</label>
            <input onfocusout={this.handleFocusOut} onKeyDown={this.handleEnter} value={emailVerify} type="email" className="form-control inputText" id="txtEmail" ref="email" placeholder="Email" name="email"/>
          </div>
          <div className="form-group">
            <label htmlFor="txtPass" className="titleText">Password</label>
            <input onfocusout={this.handleFocusOut} onKeyDown={this.handleEnter} value={passVerify} type="password"  className="form-control inputText" id="txtPass" ref="password" placeholder="Password" name="password"/>
          </div>
            <div className="form-group">
          <button type="submit" className="buttonStyle">Login</button> {buttonClear}
          </div>
        </form>
                  <div className="form-group">
      <Link className="linkText" onClick={this.resetPassword}>Reset password?</Link>
      </div>
      </div>
    );
  }

}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    loginUser,
    fetchUser,
    loginWithProvider,
    updateModal,
    clearDraw,
    updateCanvas,
    getUserData
  }, dispatch);
}

function mapStateToProps(state) {
  return {currentUser: state.currentUser, overlay: state.overlay, canvas: state.canvas};
}

export default connect(mapStateToProps, mapDispatchToProps)(UserLogin);



// WEBPACK FOOTER //
// ./src/app/components/login/index.jsx